import { apiSlice } from './apiSlice';

export const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /** Paginated: rows under `accounts.results`, total under `accounts.count`. */
    getAccounts: builder.query({
      query: (params) => ({
        url: '/v2/account-metrics/accounts/',
        params,
      }),
      providesTags: ['Account'],
    }),

    /** trader_badge, funded_balance, available_balance, pending_payout, lifetime_profit, lifetime_payouts, closest_rule_limit. */
    getDashboardStats: builder.query({
      query: () => '/v2/dashboard/',
      providesTags: ['Account'],
    }),

    /**
     * `PATCH /account/update/<login>/` — one account's own flags, a partial
     * record at a time. `public` is the one the share sheet writes: it is what
     * makes `/p/:accountId` resolve for anyone who isn't signed in.
     */
    updateAccount: builder.mutation({
      query: ({ loginId, ...body }) => ({
        url: `/account/update/${encodeURIComponent(loginId)}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Account'],
    }),

    /** `range`: 1d | 1w | 1m | 1y | all. Anything else 400s. */
    getDashboardChart: builder.query({
      query: (params) => ({
        url: '/v2/dashboard/chart/',
        params,
      }),
      providesTags: ['Account'],
    }),
  }),
});

export const {
  useGetAccountsQuery,
  useGetDashboardStatsQuery,
  useGetDashboardChartQuery,
  useUpdateAccountMutation,
} = dashboardApi;
